angular.module('examgen.directive').
filter('validExams', function() {
  return function(exams) {
    if (exams) {
      return exams.filter(function(e) {
        return !!e && !!e.loadedExam;
      });
    }
  };
});